import axios from 'axios'
import { clearAdminSession, getAdminSession, setAdminAccessMode, setAdminAccessToken } from '../utils/sessionUtils'

const API = axios.create({
    baseURL: process.env.REACT_APP_SERVER_URL,
    withCredentials: true,
})

let refreshAccessTokenPromise = null

const redirectToLogin = () => {
    clearAdminSession()
    window.location.href = '/login'
}

const refreshAdminAccessToken = async () => {
    if (!refreshAccessTokenPromise) {
        refreshAccessTokenPromise = axios
            .post(
                `${process.env.REACT_APP_SERVER_URL}/api/v1/admin/auth/token`,
                {},
                { withCredentials: true }
            )
            .then(({ data }) => {
                if (data.code !== 1 || !data.data?.accessToken) {
                    throw new Error('admin access token refresh failed')
                }

                setAdminAccessToken(data.data.accessToken)
                setAdminAccessMode(data.data.accessMode)
                return data.data.accessToken
            })
            .finally(() => {
                refreshAccessTokenPromise = null
            })
    }

    return refreshAccessTokenPromise
}

API.interceptors.request.use((req) => {
    const { accessToken } = getAdminSession()

    if (accessToken) {
        req.headers.Authorization = `Bearer ${accessToken}`
    }

    return req
})

API.interceptors.response.use(
    (res) => {
        return res
    },
    async (err) => {
        const originalConfig = err.config

        if (err.response) {
            // 엑세스 토큰 만료
            if (err.response.status === 401 && !originalConfig._retry) {
                originalConfig._retry = true

                try {
                    if (!getAdminSession().accessToken) {
                        redirectToLogin()
                        return Promise.reject(err)
                    }

                    const refreshedAccessToken = await refreshAdminAccessToken()
                    originalConfig.headers.Authorization = `Bearer ${refreshedAccessToken}`
                    return API(originalConfig)
                } catch (_error) {
                    redirectToLogin()
                    return Promise.reject(_error)
                }
            }

            if (err.response.status === 403 && err.response.data) {
                redirectToLogin()
            }
        }

        return Promise.reject(err)
    }
)

export default API
